// @flow

import React, { Component } from 'react';
import { ListGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setOperatorAction } from 'src/actions/session';

class OperatorsList extends Component {

    handleClick = (id) => {
        const { setOperatorAction } = this.props;
        setOperatorAction(id, true);
    }

    render() {
        const { operators, operatorId } = this.props;
        const items = operators.map(({ id, selected, title }) => (
            <ListGroup.Item key={id} action onClick={() => { this.handleClick(id) }} href={`#${id}`}>
                {title}
            </ListGroup.Item>
        ));
        return <ListGroup variant="flush" defaultActiveKey={`#${operatorId}`}>{items}</ListGroup>;
    }
}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId,
    operators: state.user.portalUser.operators
});

const mapDispatchToProps = {
    setOperatorAction
};

export default connect(mapStateToProps, mapDispatchToProps)(OperatorsList);


// WEBPACK FOOTER //
// ./src/components/Layout/EstablishmentModal/OperatorsList.js